// @ts-nocheck
import * as React from "react"

// TEST
import { draws } from "../../config/constants";

// Components
import Loader from "../Loader";
import Banner from "../Banner";
import CardDraw, { DrawPreview } from "../CardDraw";
import ModalInfo from "../modalInfo";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';
enum TypeCardDraw { default, large }

export const Legals = ({ setLoading, loading, data }: ComponentArticles) => {
    console.log(data);

    React.useEffect(() => {
        window.onload = function () {
            setLoading(false)
        }
    }, []);

    return (
        <main className="gallery">
            <Banner
                backImage={{ desk: `/${THEMEURL}/sources/dist/assets/images/gallery/bg-gallery.jpg`, mobile: `/${THEMEURL}/sources/dist/assets/gallery/bg-gallery.jpg` }}
                textBanner={'Bases del concurso'}
                textDescription={ data.field_title }
                newBanner={1}
            />
            <div className="gallery__content">
                <div className="gallery-container">
                    <p className="text-bases-concurso"  dangerouslySetInnerHTML={{ __html: data.field_desc }}></p>
                </div>
                <div className="btnSeeRanking">
                    <a href="/dia-del-agua">Participar</a>
                </div>
            </div>
        </main>
    )
}

export default Loader(Legals)